import { CommonModule } from '@angular/common';
import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { JsonLdDirective } from './json-ld.directive';
import { StructuredDataFactory } from './structured-data.factory';

/**
 * Factory to build the structure data
 * without any interaction with the UI.
 */
export function getStructuredDataFactory(injector: Injector): () => void {
  const result = () => {
    const factory = injector.get(StructuredDataFactory);
    factory.build();
  };
  return result;
}

@NgModule({
  imports: [CommonModule],
  declarations: [JsonLdDirective],
  exports: [JsonLdDirective],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (getStructuredDataFactory)(inject(Injector));
        return initializerFn();
      }),
  ],
})
export class StructuredDataModule {}
